<template>
  <div>
    <!-- 新增/编辑弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="90vw"
      @close="handleDialogClose"
    >
      <template slot="title">
        <div class="dialog-title-container">
          <span>{{ dialogTitle }}</span>
          <span
            class="dialog-tip"
            style="color: #f56c6c; font-size: 14px; margin-left: 20px"
            v-if="isEdit"
          >
            提示：编辑模式下仅可修改农事任务，不可添加新任务
          </span>
          <span
            class="dialog-tip"
            style="color: #f56c6c; font-size: 14px; margin-left: 20px"
            v-else-if="!viewMode"
          >
            提示：编辑修改本任务，保存后将生成新的任务
          </span>
        </div>
      </template>
      <el-form
        :model="formData"
        :rules="rules"
        ref="formRef"
        label-position="left"
        label-width="160px"
      >
        <!-- 全局设置区域 -->
        <div class="global-settings">
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="执行时间内执行频率:" prop="execFrequency">
                <!-- 非编辑模式下显示下拉 -->
                <el-select
                  v-if="!viewMode && !isEdit"
                  v-model="formData.execFrequency"
                  placeholder="请选择执行频率"
                  size="small"
                  style="width: 220px"
                >
                  <el-option
                    v-for="item in execFrequencyOptions"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  />
                </el-select>
                <!-- 编辑模式或查看模式下显示文字 -->
                <div v-else class="view-mode-text">
                  {{
                    formData.execFrequencyLabel ||
                    getExecFrequencyLabel(formData.execFrequency) ||
                    "-"
                  }}
                </div>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="提前几天生成任务:" prop="advanceDays">
                <!-- 非编辑模式下显示下拉 -->
                <el-select
                  v-if="!viewMode && !isEdit"
                  v-model="formData.advanceDays"
                  placeholder="请选择提前天数"
                  size="small"
                  style="width: 220px"
                >
                  <el-option
                    v-for="item in advanceDaysOptions"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  />
                </el-select>
                <!-- 编辑模式或查看模式下显示文字 -->
                <div v-else class="view-mode-text">
                  {{
                    formData.advanceDaysLabel ||
                    getAdvanceDaysLabel(formData.advanceDays) ||
                    "-"
                  }}
                </div>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="提前执行:" prop="canBeforeExec" required>
                <!-- 非编辑模式下显示单选按钮组 -->
                <el-radio-group
                  v-if="!viewMode && !isEdit"
                  v-model="formData.canBeforeExec"
                >
                  <el-radio :label="1">提前可执行</el-radio>
                  <el-radio :label="0">提前不可执行</el-radio>
                </el-radio-group>
                <!-- 编辑模式或查看模式下显示文字 -->
                <div v-else class="view-mode-text">
                  {{
                    formData.canBeforeExec === 1 ? "提前可执行" : "提前不可执行"
                  }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="超期执行:" prop="canAfterExec" required>
                <!-- 非编辑模式下显示单选按钮组 -->
                <el-radio-group
                  v-if="!viewMode && !isEdit"
                  v-model="formData.canAfterExec"
                >
                  <el-radio :label="1">超期限后可执行</el-radio>
                  <el-radio :label="0">超期限后不可执行</el-radio>
                </el-radio-group>
                <!-- 编辑模式或查看模式下显示文字 -->
                <div v-else class="view-mode-text">
                  {{
                    formData.canAfterExec === 1
                      ? "超期限后可执行"
                      : "超期限后不可执行"
                  }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="启用状态:" prop="enabled">
                <!-- 非查看模式下显示开关 -->
                <el-switch
                  v-if="!viewMode"
                  v-model="formData.enabled"
                  :active-value="1"
                  :inactive-value="0"
                >
                </el-switch>
                <!-- 查看模式下显示文字 -->
                <div v-else class="view-mode-text">
                  {{ formData.enabled === 1 ? "启用" : "禁用" }}
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <!-- 农事任务配置区域 -->
        <div class="task-config">
          <h3>农事任务</h3>
          <el-table :data="formData.details" border style="width: 100%">
            <el-table-column
              label="序号"
              type="index"
              width="60"
              align="center"
            ></el-table-column>
            <el-table-column width="120">
              <template slot="header" slot-scope="">
                <span>大棚编号</span
                ><span style="color: #f56c6c; margin-left: 2px">*</span>
              </template>
              <template slot-scope="scope">
                <!-- 编辑模式下显示选择器 -->
                <el-select
                  v-if="!viewMode"
                  v-model="scope.row.greenhouseId"
                  placeholder="请选择"
                  style="width: 100%"
                  @change="handleTaskGreenhouseChange(scope.$index)"
                >
                  <el-option
                    v-for="item in greenhouseOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <!-- 查看模式下显示文字 -->
                <div v-else class="view-mode-text">
                  {{ getGreenhouseName(scope.row.greenhouseId) }}
                </div>
              </template>
            </el-table-column>
            <el-table-column width="150">
              <template slot="header" slot-scope="">
                <span>任务分类</span
                ><span style="color: #f56c6c; margin-left: 2px">*</span>
              </template>
              <template slot-scope="scope">
                <!-- 编辑模式下显示选择器 -->
                <el-select
                  v-if="!viewMode"
                  v-model="scope.row.categoryId"
                  placeholder="请选择"
                  style="width: 100%"
                  @change="handleCategoryChange(scope.$index)"
                >
                  <el-option
                    v-for="item in taskCategoryOptions"
                    :key="item.categoryId"
                    :label="item.label"
                    :value="item.categoryId"
                  >
                  </el-option>
                </el-select>
                <!-- 查看模式下显示文字 -->
                <div v-else class="view-mode-text">
                  {{ scope.row.categoryName }}
                </div>
              </template>
            </el-table-column>
            <el-table-column width="200">
              <template slot="header" slot-scope="">
                <span>农事动作</span
                ><span style="color: #f56c6c; margin-left: 2px">*</span>
              </template>
              <template slot-scope="scope">
                <!-- 编辑模式下显示输入框 -->
                <el-input
                  v-if="!viewMode"
                  v-model="scope.row.actions"
                  placeholder="请输入农事动作"
                  size="mini"
                >
                </el-input>
                <!-- 查看模式下显示文字 -->
                <div v-else class="view-mode-text">
                  {{ scope.row.actions || "-" }}
                </div>
              </template>
            </el-table-column>
            <el-table-column width="200">
              <template slot="header" slot-scope="">
                <span>重点防治病虫害</span>
              </template>
              <template slot-scope="scope">
                <!-- 编辑模式下显示输入框 -->
                <el-input
                  v-if="!viewMode"
                  v-model="scope.row.pestControl"
                  placeholder="请输入"
                  size="mini"
                >
                </el-input>
                <!-- 查看模式下显示文字 -->
                <div v-else class="view-mode-text">
                  {{ scope.row.pestControl || "-" }}
                </div>
              </template>
            </el-table-column>
            <el-table-column width="200">
              <template slot="header" slot-scope="">
                <span>温湿度要求</span>
              </template>
              <template slot-scope="scope">
                <!-- 编辑模式下显示输入框 -->
                <el-input
                  v-if="!viewMode"
                  v-model="scope.row.stdHumidityTemp"
                  placeholder="请输入"
                  size="mini"
                >
                </el-input>
                <!-- 查看模式下显示文字 -->
                <div v-else class="view-mode-text">
                  {{ scope.row.stdHumidityTemp || "-" }}
                </div>
              </template>
            </el-table-column>
            <el-table-column width="250">
              <template slot="header" slot-scope="">
                <span>执行时间</span
                ><span style="color: #f56c6c; margin-left: 2px">*</span>
              </template>
              <template slot-scope="scope">
                <!-- 编辑模式下显示日期选择器 -->
                <el-date-picker
                  v-if="!viewMode"
                  v-model="scope.row.execDateRange"
                  type="daterange"
                  size="mini"
                  style="width: 100%"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @input="handleExecDateChange(scope.$index)"
                  @change="handleExecDateChange(scope.$index)"
                  format="yyyy-MM-dd"
                >
                </el-date-picker>
                <!-- 查看模式下显示文字 -->
                <div v-else class="view-mode-text">
                  {{ formatExecDateRange(scope.row) }}
                </div>
              </template>
            </el-table-column>
            <el-table-column width="180">
              <template slot="header" slot-scope="">
                <span>执行人</span
                ><span style="color: #f56c6c; margin-left: 2px">*</span>
              </template>
              <template slot-scope="scope">
                <!-- 编辑模式下显示input和弹出框选择器 -->
                <div v-if="!viewMode" class="executor-selector">
                  <!-- 弹出框选择器 -->
                  <el-popover
                    :ref="`executorPopover${scope.$index}`"
                    placement="bottom"
                    width="500"
                    trigger="click"
                    @show="handleExecutorPopoverShow(scope.$index)"
                  >
                    <div class="executor-popover-content">
                      <div class="executor-layout">
                        <!-- 左侧：标题列 -->
                        <div class="executor-left-panel">
                          <div class="panel-content">
                            <div class="executor-title">执行人</div>
                          </div>
                        </div>

                        <!-- 右侧：执行人列表 -->
                        <div class="executor-right-panel">
                          <div class="panel-content">
                            <el-radio-group
                              v-model="scope.row.tempExecutorId"
                              @change="
                                handleExecutorSelect(scope.$index, $event)
                              "
                            >
                              <el-radio
                                v-for="account in executorCascaderOptions"
                                :key="account.id"
                                :label="account.id"
                              >
                                {{ account.name }}
                              </el-radio>
                            </el-radio-group>
                          </div>
                        </div>
                      </div>

                      <!-- 底部按钮 -->
                      <div class="executor-popover-actions">
                        <el-button
                          size="mini"
                          @click="handleExecutorCancel(scope.$index)"
                          >取消</el-button
                        >
                        <el-button
                          size="mini"
                          type="primary"
                          @click="handleExecutorConfirm(scope.$index)"
                          >确定</el-button
                        >
                      </div>
                    </div>
                    <!-- 将input作为reference元素 -->
                    <el-input
                      slot="reference"
                      v-model="scope.row.executorNickName"
                      placeholder="请选择执行人"
                      size="mini"
                      readonly
                      style="width: 100%"
                    >
                    </el-input>
                  </el-popover>
                </div>
                <!-- 查看模式下显示文字 -->
                <div v-else class="view-mode-text">
                  {{ getExecutorName(scope.row.executorId) }}
                </div>
              </template>
            </el-table-column>

            <el-table-column width="195">
              <template slot="header" slot-scope="">
                <span>优先级</span
                ><span style="color: #f56c6c; margin-left: 2px">*</span>
              </template>
              <template slot-scope="scope">
                <!-- 编辑模式下显示数字输入框 -->
                <el-input-number
                  v-if="!viewMode"
                  v-model="scope.row.priority"
                  :min="1"
                  :max="999"
                  :precision="0"
                  placeholder="请输入"
                  size="mini"
                  style="width: 188px"
                >
                </el-input-number>
                <!-- 查看模式下显示文字 -->
                <div v-else class="view-mode-text">
                  {{ scope.row.priority || "-" }}
                </div>
              </template>
            </el-table-column>

            <el-table-column label="指导文件" width="120">
              <template slot-scope="scope">
                <div class="file-upload-container">
                  <!-- 编辑模式下显示上传按钮 -->
                  <el-upload
                    v-if="
                      !viewMode &&
                      (!scope.row.guidanceFiles ||
                        scope.row.guidanceFiles.length === 0)
                    "
                    :action="uploadUrl"
                    :on-success="
                      (res, file) =>
                        handleUploadSuccess(res, scope.$index, file)
                    "
                    :on-error="handleUploadError"
                    :before-upload="
                      (file) => handleBeforeUpload(file, scope.$index)
                    "
                    :accept="'.pdf,.jpg,.jpeg,.png,.gif,.mp4'"
                    :show-file-list="false"
                    size="mini"
                  >
                    <el-button size="mini" type="primary" icon="el-icon-upload"
                      >上传</el-button
                    >
                  </el-upload>

                  <!-- 如果已有文件，显示文件信息和操作按钮 -->
                  <div
                    v-if="
                      scope.row.guidanceFiles &&
                      scope.row.guidanceFiles.length > 0
                    "
                    class="file-list"
                  >
                    <div class="file-item">
                      <span class="file-name">{{
                        getFileName(scope.row.guidanceFiles[0])
                      }}</span>
                      <div class="file-actions" v-if="!viewMode">
                        <el-button
                          type="text"
                          size="mini"
                          @click="replaceFile(scope.$index)"
                          style="color: #409eff; margin-right: 5px"
                        >
                          替换
                        </el-button>
                        <el-button
                          type="text"
                          size="mini"
                          @click="removeFile(scope.$index, 0)"
                          style="color: #f56c6c"
                        >
                          删除
                        </el-button>
                      </div>
                    </div>
                  </div>

                  <!-- 查看模式下显示文件信息 -->
                  <div
                    v-if="
                      viewMode &&
                      scope.row.guidanceFiles &&
                      scope.row.guidanceFiles.length > 0
                    "
                    class="view-mode-text"
                  >
                    <span class="file-name">{{
                      getFileName(scope.row.guidanceFiles[0])
                    }}</span>
                    <el-button
                      size="mini"
                      @click="downloadFile(scope.row.guidanceFiles[0])"
                      style="color: #409eff; margin-left: 8px"
                    >
                      <i class="el-icon-download"></i> 下载
                    </el-button>
                  </div>

                  <!-- 查看模式下如果没有文件显示提示 -->
                  <div
                    v-if="
                      viewMode &&
                      (!scope.row.guidanceFiles ||
                        scope.row.guidanceFiles.length === 0)
                    "
                    class="view-mode-text"
                  >
                    -
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="注意事项" width="200">
              <template slot-scope="scope">
                <!-- 编辑模式下显示输入框 -->
                <el-input
                  v-if="!viewMode"
                  v-model="scope.row.precautions"
                  placeholder="请输入"
                  size="mini"
                >
                </el-input>
                <!-- 查看模式下显示文字 -->
                <div v-else class="view-mode-text">
                  {{ scope.row.precautions || "-" }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="80"
              v-if="!viewMode && !isEdit"
            >
              <template slot-scope="scope">
                <el-button
                  type="danger"
                  size="mini"
                  @click="removeTask(scope.$index)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="add-task-btn" v-if="!viewMode && !isEdit">
            <el-button
              type="primary"
              style="width: 100%; margin: 15px 0"
              icon="el-icon-plus"
              @click="addTask"
              >添加</el-button
            >
          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">{{
          viewMode ? "关闭" : "取消"
        }}</el-button>
        <el-button
          type="primary"
          @click="handleSubmit"
          v-if="!viewMode"
          need-listen
          data-module="任务分配提交"
          data-event-name="handleSubmitTaskAllocation"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <!-- 查看详情弹窗 -->
    <el-dialog title="查看详情" :visible.sync="viewDialogVisible" width="500px">
      <div v-if="!isEdit">
        <p>
          <strong>提前可执行：</strong
          >{{ editData.canBeforeExec === 1 ? "是" : "否" }}
        </p>
        <p>
          <strong>超期限后可执行：</strong
          >{{ editData.canAfterExec === 1 ? "是" : "否" }}
        </p>
        <p>
          <strong>状态：</strong>{{ editData.enabled === 1 ? "启用" : "禁用" }}
        </p>
        <p><strong>更新时间：</strong>{{ formatTime(editData.updateTime) }}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="viewDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "@/axios";
import { baseUrl, uploadUrl } from "@/axios/baseUrl";
import dayjs from "dayjs";

export default {
  name: "AssignDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    viewMode: {
      type: Boolean,
      default: false,
    },
    editData: {
      type: Object,
      default: () => ({}),
    },
    greenhouseOptions: {
      type: Array,
      default: () => [],
    },
    apiEndpoint: {
      type: String,
      default: "",
    },
    taskCategoryOptions: {
      type: Array,
      default: () => [],
    },
    executorCascaderOptions: {
      type: Array,
      default: () => [],
    },
    greenhouseId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dialogVisible: false,
      dialogTitle: "新增任务分配",
      isInitializing: false, // 防止 watcher 无限循环的标志
      formData: {
        id: "",
        // 新增：执行频率与提前生成天数
        execFrequency: "",
        advanceDays: "",
        canBeforeExec: 1,
        canAfterExec: 1,
        details: [
          {
            greenhouseId: "",
            greenhouseName: "",
            taskConfigId: null,
            categoryId: "",
            categoryName: "",
            actions: "",
            pestControl: "",
            stdHumidityTemp: "",
            execStartDate: "",
            execEndDate: "",
            execDateRange: [],
            executorId: "",
            executorUsername: "",
            executorNickName: "",
            executorDisplayName: "",
            priority: 1,
            guidanceFiles: [],
            pendingFiles: [],
            precautions: "",
          },
        ],
        enabled: 1,
      },
      rules: {
        execFrequency: [
          { required: true, message: "请选择执行频率", trigger: "change" },
        ],
        advanceDays: [
          { required: true, message: "请选择提前天数", trigger: "change" },
        ],
      },
      viewDialogVisible: false,
      viewRow: {},
      uploadUrl: uploadUrl,
      // 下拉选项数据
      execFrequencyOptions: [],
      advanceDaysOptions: [],
    };
  },
  watch: {
    visible(val) {
      // 避免重复设置相同的值
      if (this.dialogVisible !== val) {
        this.dialogVisible = val;
        // 当弹窗显示时，根据当前状态设置标题
        if (val) {
          if (this.viewMode) {
            this.dialogTitle = "查看详情";
          } else {
            this.dialogTitle = this.isEdit ? "编辑任务分配" : "新增任务分配";
          }
        }
      }
    },
    isEdit(val) {
      // 只有在非查看模式下才根据isEdit设置标题
      if (!this.viewMode) {
        this.dialogTitle = val ? "编辑任务分配" : "新增任务分配";
      }
    },
    viewMode(val) {
      if (val) {
        this.dialogTitle = "查看详情";
      } else {
        // 只有在非查看模式下才根据isEdit设置标题
        this.dialogTitle = this.isEdit ? "编辑任务分配" : "新增任务分配";
      }
    },
    editData: {
      handler(val, oldVal) {
        // 避免无限循环：只有当数据真正发生变化且不在初始化过程中时才处理
        if (val && Object.keys(val).length > 0 && !this.isInitializing) {
          this.isInitializing = true;
          // 使用 nextTick 避免在 watcher 中直接修改数据
          this.$nextTick(() => {
            this.initFormData(val);
            this.isInitializing = false;
          });
        }
      },
      deep: true,
      immediate: false,
    },
  },
  mounted() {
    // 加载下拉选项
    this.fetchExecFrequencyOptions();
    this.fetchAdvanceDaysOptions();
  },
  methods: {
    getFileName(file) {
      const list = file.split("/");
      return list[list.length - 1];
    },
    formatTime(time) {
      if (!time) return "";
      const date = new Date(time);
      return date
        .toLocaleString("zh-CN", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        })
        .replace(/\//g, "/");
    },
    formatDate(date) {
      if (!date) return "";
      return dayjs(date).format("YYYY-MM-DD");
    },
    initFormData(data) {
      // 深拷贝数据，避免直接修改 props
      const clonedData = JSON.parse(JSON.stringify(data));

      // 确保标题正确设置
      if (this.viewMode) {
        this.dialogTitle = "查看详情";
      } else {
        this.dialogTitle = this.isEdit ? "编辑任务分配" : "新增任务分配";
      }

      // 批量更新，减少响应式更新次数
      setTimeout(() => {
        this.formData = {
          ...clonedData,
          details: clonedData.details || [],
        };

        // 为每个任务设置默认大棚和初始化
        if (this.formData.details) {
          this.formData.details.forEach((task, index) => {
            // 如果任务没有大棚ID，使用传入的默认大棚ID
            if (!task.greenhouseId && this.greenhouseId) {
              task.greenhouseId = this.greenhouseId;
              const selectedGreenhouse = this.greenhouseOptions.find(
                (item) => item.value === this.greenhouseId
              );
              if (selectedGreenhouse) {
                task.greenhouseName = selectedGreenhouse.label;
              }
            }

            if (!task.guidanceFiles) {
              task.guidanceFiles = [];
            }
            if (!task.pendingFiles) {
              task.pendingFiles = [];
            }

            // 确保执行人ID是数字格式
            if (task.executorId && typeof task.executorId === "string") {
              task.executorId = parseInt(task.executorId);
            }
            console.log("临时选择task", task);
            // 初始化临时选择字段
            if (typeof task.tempExecutorId === "undefined") {
              this.$set(task, "tempExecutorId", "");
            }
            if (typeof task.tempExecutorUsername === "undefined") {
              this.$set(task, "tempExecutorUsername", "");
            }
            if (typeof task.tempExecutorNickName === "undefined") {
              this.$set(task, "tempExecutorNickName", "");
            }

            if (task.execStartDate && task.execEndDate) {
              this.$set(task, "execDateRange", [
                new Date(task.execStartDate),
                new Date(task.execEndDate),
              ]);
            } else {
              this.$set(task, "execDateRange", []);
            }
          });
        }

        // 确保执行人显示名称在选项数据准备好后更新
        this.updateExecutorDisplayNames();
      }, 1000);
    },
    handleDialogClose() {
      this.$refs.formRef && this.$refs.formRef.resetFields();
      this.formData = {
        id: null,
        canBeforeExec: 1,
        canAfterExec: 1,
        details: [
          {
            greenhouseId: this.greenhouseId || "",
            greenhouseName: "",
            taskConfigId: null,
            categoryId: "",
            categoryName: "",
            actions: "",
            pestControl: "",
            stdHumidityTemp: "",
            execStartDate: "",
            execEndDate: "",
            execDateRange: [],
            executorId: "",
            executorUsername: "",
            executorNickName: "",
            executorDisplayName: "",
            priority: 1,
            guidanceFiles: [],
            pendingFiles: [],
            precautions: "",
          },
        ],
        enabled: 1,
      };
      // 重置执行人选择器聚焦状态
      // this.executorFocusedStates = {} // 删除
      this.$emit("update:visible", false);
    },
    handleCancel() {
      this.$emit("update:visible", false);
    },
    async handleSubmit() {
      if (this.viewMode) {
        return;
      }

      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          // 校验表格中的必填项
          if (!this.validateTableData()) {
            return;
          }

          try {
            const submitData = { ...this.formData };
            let url = this.isEdit
              ? "/api/digital-farming/task/allot/edit"
              : "/api/digital-farming/task/allot/add";

            // 如果指定了自定义接口，则使用自定义接口
            if (this.apiEndpoint) {
              url = this.apiEndpoint;
            }

            const res = await axios.post(baseUrl + url, submitData);
            if (res.code === 200) {
              this.$message.success(this.isEdit ? "更新成功" : "新增成功");
              this.$emit("success");
              this.$emit("update:visible", false);
            }
          } catch (error) {
            console.error("提交失败:", error);
          }
        }
      });
    },
    validateTableData() {
      if (!this.formData.details || this.formData.details.length === 0) {
        this.$message.error("请至少添加一条农事任务");
        return false;
      }

      for (let i = 0; i < this.formData.details.length; i++) {
        const task = this.formData.details[i];

        // 校验大棚编号
        if (!task.greenhouseId) {
          this.$message.error(`第${i + 1}行：请选择大棚编号`);
          return false;
        }

        // 校验任务分类
        if (!task.categoryId) {
          this.$message.error(`第${i + 1}行：请选择任务分类`);
          return false;
        }

        // 校验农事动作
        if (!task.actions || !task.actions.trim()) {
          this.$message.error(`第${i + 1}行：请输入农事动作`);
          return false;
        }

        // 校验执行时间
        if (!task.execDateRange || task.execDateRange.length !== 2) {
          this.$message.error(`第${i + 1}行：请选择执行时间`);
          return false;
        }

        // 校验执行人
        if (!task.executorId) {
          this.$message.error(`第${i + 1}行：请选择执行人`);
          return false;
        }

        // 校验优先级
        if (!task.priority || task.priority < 1) {
          this.$message.error(`第${i + 1}行：请输入有效的优先级（1-999）`);
          return false;
        }
      }

      return true;
    },
    // 任务大棚变化处理
    handleTaskGreenhouseChange(index) {
      if (this.viewMode) return;

      const task = this.formData.details[index];
      const selectedGreenhouse = this.greenhouseOptions.find(
        (item) => item.value === task.greenhouseId
      );
      if (selectedGreenhouse) {
        task.greenhouseName = selectedGreenhouse.label;
      }
    },
    // 添加任务
    addTask() {
      if (this.viewMode) return;

      this.formData.details.push({
        greenhouseId: "",
        greenhouseName: "",
        taskConfigId: null,
        categoryId: "",
        categoryName: "",
        actions: "",
        pestControl: "",
        stdHumidityTemp: "",
        execStartDate: "",
        execEndDate: "",
        execDateRange: [],
        executorId: "",
        executorUsername: "",
        executorNickName: "",
        executorDisplayName: "",
        priority: 1,
        // 临时选择字段
        tempExecutorId: "",
        tempExecutorUsername: "",
        tempExecutorNickName: "",
        guidanceFiles: [],
        pendingFiles: [],
        precautions: "",
      });
    },
    // 删除任务
    removeTask(index) {
      if (this.viewMode) return;

      if (this.formData.details.length <= 1) {
        this.$message.warning("至少需要保留一条农事任务");
        return;
      }
      this.formData.details.splice(index, 1);
    },
    // 任务分类变化处理
    handleCategoryChange(index) {
      console.log(this.taskCategoryOptions);

      if (this.viewMode) return;

      const task = this.formData.details[index];
      console.log("task", task);
      const selectedCategory = this.taskCategoryOptions.find(
        (item) => item.categoryId == task.categoryId
      );
      console.log("selectedCategory", selectedCategory, task.categoryId);

      if (selectedCategory) {
        // task.taskConfigId = selectedCategory.value
        task.categoryId = selectedCategory.categoryId;
        task.categoryName = selectedCategory.label;

        // 清空农事动作相关字段，让用户重新选择
        task.actions = "";
        task.pestControl = "";
        task.stdHumidityTemp = "";
      }
    },

    // 新增：处理执行人选择
    handleExecutorSelect(index, executorId) {
      if (this.viewMode) return;

      const task = this.formData.details[index];

      // 只设置临时执行人ID，不直接赋值
      this.$set(task, "tempExecutorId", executorId);

      // 根据ID获取执行人信息，设置到临时字段
      const executor = this.executorCascaderOptions.find(
        (item) => item.id === executorId
      );
      console.log("执行人选择", executor);

      if (executor) {
        this.$set(task, "tempExecutorUsername", executor.username);
        this.$set(task, "tempExecutorNickName", executor.nickName);
      }
    },

    // 处理弹出框显示
    handleExecutorPopoverShow(index) {
      if (this.viewMode) return;

      const task = this.formData.details[index];

      // 确保数据已经准备好
      this.$nextTick(() => {
        // 初始化临时选择状态
        if (task.executorId) {
          // 如果已有执行人，设置临时选择状态
          this.$set(task, "tempExecutorId", task.executorId);
          this.$set(task, "tempExecutorUsername", task.executorUsername);
          this.$set(task, "tempExecutorNickName", task.executorNickName);
        } else {
          // 如果没有执行人，清空临时选择状态
          this.$set(task, "tempExecutorId", "");
          this.$set(task, "tempExecutorUsername", "");
          this.$set(task, "tempExecutorNickName", "");
        }

        console.log("弹出框显示，当前执行人ID:", task.executorId);
        console.log("临时选择状态:", task.tempExecutorId);
      });
    },

    // 处理执行人选择确认
    handleExecutorConfirm(index) {
      if (this.viewMode) return;

      const task = this.formData.details[index];

      // 检查是否选择了执行人
      if (!task.tempExecutorId) {
        this.$message.warning("请先选择执行人");
        return;
      }
      console.log("确认选择", task);
      // 确认选择，将临时值赋给正式字段
      this.$set(task, "executorId", task.tempExecutorId);
      this.$set(task, "executorUsername", task.tempExecutorUsername);
      this.$set(task, "executorNickName", task.tempExecutorNickName);
      this.$set(task, "executorDisplayName", task.executorDisplayName);

      // 关闭弹出框
      const popoverRef = this.$refs[`executorPopover${index}`];
      if (popoverRef && popoverRef.doClose) {
        popoverRef.doClose();
      }
    },

    // 处理执行人选择取消
    handleExecutorCancel(index) {
      if (this.viewMode) return;

      const task = this.formData.details[index];

      // 清空临时选择字段
      this.$set(task, "tempExecutorId", "");
      this.$set(task, "tempExecutorUsername", "");
      this.$set(task, "tempExecutorNickName", "");

      // 关闭弹出框
      const popoverRef = this.$refs[`executorPopover${index}`];
      if (popoverRef && popoverRef.doClose) {
        popoverRef.doClose();
      }
    },

    // 执行时间变化处理
    handleExecDateChange(index) {
      if (this.viewMode) return;

      const task = this.formData.details[index];

      if (!task) {
        console.error("task 不存在，index:", index);
        return;
      }

      if (task.execDateRange && task.execDateRange.length === 2) {
        // 确保日期是有效的Date对象
        const startDate =
          task.execDateRange[0] instanceof Date
            ? task.execDateRange[0]
            : new Date(task.execDateRange[0]);
        const endDate =
          task.execDateRange[1] instanceof Date
            ? task.execDateRange[1]
            : new Date(task.execDateRange[1]);

        task.execStartDate = this.formatDate(startDate);
        task.execEndDate = this.formatDate(endDate);

        // 实时校验执行时间是否在生长时期范围内
        const growthStartDate = this.formData.startDate;
        const growthEndDate = this.formData.endDate;

        if (growthStartDate && growthEndDate) {
          const taskStartDate = this.formatDate(startDate);
          const taskEndDate = this.formatDate(endDate);

          if (taskStartDate < growthStartDate || taskEndDate > growthEndDate) {
            this.$message.warning(
              `第${index + 1}行：执行时间超出生长时期范围（${this.formatDate(
                growthStartDate
              )} 至 ${this.formatDate(growthEndDate)}）`
            );
            // 使用 $set 确保响应式更新
            this.$set(this.formData.details[index], "execDateRange", []);
            return;
          }
        }

        // 校验通过后，确保 execDateRange 保持为 Date 对象数组
        this.$set(this.formData.details[index], "execDateRange", [
          startDate,
          endDate,
        ]);
      }
    },
    // 文件上传前验证
    handleBeforeUpload(file, taskIndex) {
      if (this.viewMode) return false;

      const allowedTypes = ["pdf", "jpg", "jpeg", "png", "gif", "mp4"];
      const fileExtension = file.name.split(".").pop().toLowerCase();

      if (!allowedTypes.includes(fileExtension)) {
        this.$message.error("只支持上传 PDF、JPG、PNG、GIF、MP4 格式的文件");
        return false;
      }

      // 文件大小限制 (50MB)
      const maxSize = 50 * 1024 * 1024;
      if (file.size > maxSize) {
        this.$message.error("文件大小不能超过 50MB");
        return false;
      }

      // 保存本地文件名到任务中，用于后续显示
      const task = this.formData.details[taskIndex];
      if (!task.pendingFiles) {
        task.pendingFiles = [];
      }
      task.pendingFiles.push({
        name: file.name,
        size: file.size,
      });

      return true;
    },
    // 文件上传成功处理
    handleUploadSuccess(res, index, file) {
      if (this.viewMode) return;

      if (res.code === 200) {
        const task = this.formData.details[index];
        if (!task.guidanceFiles) {
          task.guidanceFiles = [];
        }

        // 获取对应的本地文件名
        let localFileName = file.name;
        if (task.pendingFiles && task.pendingFiles.length > 0) {
          // 找到对应的待上传文件信息
          const pendingFile = task.pendingFiles.find(
            (pending) =>
              pending.name === file.name && pending.size === file.size
          );
          if (pendingFile) {
            localFileName = pendingFile.name;
            // 从待上传列表中移除
            const pendingIndex = task.pendingFiles.indexOf(pendingFile);
            if (pendingIndex > -1) {
              task.pendingFiles.splice(pendingIndex, 1);
            }
          }
        }

        // 确保只保存一个文件，替换现有文件
        task.guidanceFiles = [res.data];
        this.$message.success("文件上传成功");
      } else {
        this.$message.error(res.message || "文件上传失败");
      }
    },
    // 文件上传失败处理
    handleUploadError() {
      if (this.viewMode) return;
      this.$message.error("文件上传失败");
    },
    // 删除文件
    removeFile(taskIndex, fileIndex) {
      if (this.viewMode) return;

      const task = this.formData.details[taskIndex];
      if (task.guidanceFiles && task.guidanceFiles.length > fileIndex) {
        task.guidanceFiles.splice(fileIndex, 1);
        this.$message.success("文件删除成功");
      }
    },
    // 替换文件
    replaceFile(taskIndex) {
      if (this.viewMode) return;

      const task = this.formData.details[taskIndex];
      // 清空现有文件，显示上传按钮
      task.guidanceFiles = [];
      this.$message.info("请选择新文件进行替换");
    },
    // 显示查看详情弹窗
    showViewDialog(row) {
      this.viewRow = { ...row };
      this.viewDialogVisible = true;
    },
    // 获取大棚名称
    getGreenhouseName(greenhouseId) {
      const greenhouse = this.greenhouseOptions.find(
        (item) => item.value === greenhouseId
      );
      return greenhouse ? greenhouse.label : greenhouseId;
    },
    // 获取任务分类名称
    getTaskCategoryName(categoryId) {
      const category = this.taskCategoryOptions.find(
        (item) => item.value === categoryId
      );
      return category ? category.label : categoryId;
    },

    // 更新所有任务的执行人显示名称
    updateExecutorDisplayNames() {
      if (this.formData.details && this.formData.details.length > 0) {
        console.log("初始化执行人显示名称");

        this.$nextTick(() => {
          this.formData.details.forEach((task, index) => {
            task.executorId = task.executorId.toString();
            if (task.executorId) {
              const displayName = this.getExecutorDisplayName(task.executorId);
              console.log("找到的执行人", displayName);
              this.$set(
                this.formData.details[index],
                "executorUsername",
                displayName
              );
            }
          });
          console.log("处理后数据", this.formData.details);
        });
      }

      // 确保执行频率和提前天数的显示名称在查看模式下正确设置
      if (this.viewMode && this.formData) {
        this.$nextTick(() => {
          // 为执行频率和提前天数添加显示字段
          if (this.formData.execFrequency) {
            const frequencyLabel = this.getExecFrequencyLabel(
              this.formData.execFrequency
            );
            this.$set(this.formData, "execFrequencyLabel", frequencyLabel);
          }
          if (this.formData.advanceDays) {
            const advanceLabel = this.getAdvanceDaysLabel(
              this.formData.advanceDays
            );
            this.$set(this.formData, "advanceDaysLabel", advanceLabel);
          }
        });
      }
    },

    // 获取执行人显示名称
    getExecutorDisplayName(executorId) {
      if (!executorId) return "";

      // 直接从执行人列表中查找
      const executor = this.executorCascaderOptions.find(
        (item) => item.id == executorId
      );
      return executor ? executor.name : "";
    },

    // 获取执行人名称
    getExecutorName(executorId) {
      if (!executorId) return "";

      // 直接从执行人列表中查找
      const executor = this.executorCascaderOptions.find(
        (item) => item.id === executorId
      );
      return executor ? executor.name : executorId;
    },

    // 加载执行频率选项
    async fetchExecFrequencyOptions() {
      try {
        const res = await axios.get(
          baseUrl + "/api/digital-farming/task/allot/select/exec-frequency"
        );
        if (res && res.code === 200 && Array.isArray(res.data)) {
          this.execFrequencyOptions = res.data;
        } else {
          console.warn("加载执行频率选项失败", res);
        }
      } catch (error) {
        console.error("加载执行频率选项出错:", error);
      }
    },

    // 加载提前几天生成任务选项
    async fetchAdvanceDaysOptions() {
      try {
        const res = await axios.get(
          baseUrl + "/api/digital-farming/task/allot/select/advance-days"
        );
        if (res && res.code === 200 && Array.isArray(res.data)) {
          this.advanceDaysOptions = res.data;
        } else {
          console.warn("加载提前天数选项失败", res);
        }
      } catch (error) {
        console.error("加载提前天数选项出错:", error);
      }
    },

    // 根据值返回执行频率的显示名称
    getExecFrequencyLabel(value) {
      if (!value) return "";
      const item =
        this.execFrequencyOptions.find((opt) => opt.key == value) || null;
      return item ? item.value : value;
    },

    // 根据值返回提前天数的显示名称
    getAdvanceDaysLabel(value) {
      if (!value) return "";
      const item =
        this.advanceDaysOptions.find((opt) => opt.key == value) || null;
      return item ? item.value : value;
    },

    // 格式化执行时间范围
    formatExecDateRange(task) {
      if (!task.execDateRange || task.execDateRange.length !== 2) {
        return "-";
      }
      const startDate = this.formatDate(task.execDateRange[0]);
      const endDate = this.formatDate(task.execDateRange[1]);
      return `${startDate} - ${endDate}`;
    },
    // 下载文件
    async downloadFile(fileUrl) {
      try {
        const fileName = this.getFileName(fileUrl);

        // 创建下载链接
        const link = document.createElement("a");
        link.href = baseUrl + fileUrl;
        link.download = fileName;
        link.target = "_blank";

        // 添加到DOM并触发点击
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.$message.success("文件下载已开始");
      } catch (error) {
        console.error("文件下载失败:", error);
        this.$message.error("文件下载失败");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.basic-config {
  margin-bottom: 20px;
  padding: 15px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
}

.task-config {
  margin-bottom: 20px;

  h3 {
    color: #fff;
    margin-bottom: 15px;
    font-size: 16px;
  }

  .add-task-btn {
    margin-top: 15px;
    text-align: center;
  }
}

.global-settings {
  padding: 15px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
}

// 文件上传样式
.file-upload-container {
  .file-list {
    margin-top: 5px;

    .file-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 2px 0;
      font-size: 12px;

      .file-name {
        color: #409eff;
        max-width: 60px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .file-actions {
        display: flex;
        align-items: center;
      }
    }
  }
}

.view-mode-text {
  color: #606266;
  font-size: 14px;

  .file-name {
    color: #409eff;
    font-weight: 500;
  }
}

.executor-selector {
  position: relative;
  display: inline-block;
  width: 100%;

  .el-input {
    cursor: pointer;

    &:hover {
      .el-input__inner {
        border-color: #409eff;
      }
    }
  }
}

// 执行人弹出框样式
.executor-popover-content {
  padding: 0;

  .executor-layout {
    display: flex;
    min-height: 200px;

    // 左侧面板
    .executor-left-panel {
      width: 80px;
      min-width: 80px;
      text-align: center;
      padding: 8px 0;
      background-color: #f5f7fa;
      border-right: 1px solid #ebeef5;

      .panel-content {
        height: 100%;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;

        .executor-title {
          color: #303133;
          font-size: 14px;
          font-weight: 500;
        }
      }
    }

    // 右侧面板
    .executor-right-panel {
      flex: 1;
      min-width: 200px;

      .panel-content {
        padding: 8px 0;
        max-height: 150px;
        overflow-y: auto;

        .el-radio-group {
          width: 100%;

          .el-radio {
            margin: 0;
            padding: 8px 16px;
            width: 100%;
            display: block;
            border-radius: 0;
            transition: all 0.3s;

            &:hover {
              background-color: #f0f9ff;
              color: #409eff;
            }

            &.is-checked {
              background-color: #ecf5ff;
              color: #409eff;
            }

            .el-radio__label {
              font-size: 13px;
            }
          }
        }
      }
    }
  }

  // 底部按钮
  .executor-popover-actions {
    display: flex;
    justify-content: center;
    gap: 10px;
    padding: 16px;
    border-top: 1px solid #ebeef5;
    background-color: #fff;

    .el-button {
      min-width: 60px;
    }
  }
}

// 弹窗标题样式
.dialog-title-container {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-size: 22px;
  font-weight: bold;
  .dialog-tip {
    font-weight: normal;
    line-height: 1.2;
  }
}
</style>
